// Dependecies
import { createStore, createHook } from 'react-sweet-state';

// Helpers

const initialState = {
  dateRequest: '',
  hourRequest: '',
  placeRequest: '',
  descriptionRequest: '',
  cityRequest: '',
  userVehicleRequest: '',
};

const actions = {
  setDateRequest:
    (dateRequest) =>
    ({ setState }) => {
      setState({ dateRequest });
    },
  setHourRequest:
    (hourRequest) =>
    ({ setState }) => {
      setState({ hourRequest });
    },
  setPlaceRequest:
    (placeRequest) =>
    ({ setState }) => {
      setState({ placeRequest });
    },
  setDescriptionRequest:
    (descriptionRequest) =>
    ({ setState }) => {
      setState({ descriptionRequest });
    },
  setCityRequest:
    (cityRequest) =>
    ({ setState }) => {
      setState({ cityRequest });
    },
  setUserVehicleRequest:
    (userVehicleRequest) =>
    ({ setState }) => {
      setState({ userVehicleRequest });
    },
};

const Store = createStore({
  initialState,
  actions,
  name: 'dateService',
});

export default createHook(Store);
